import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseInventoryRelocationActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/WarehouseMove/WarehouseMoveBrowser")
	}

	render() {
		return (
			<Activity 
				name="WarehouseInventoryRelocation"
				RenderedComponent={this.RenderedComponent}
				context="WarehouseInventoryRelocation"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseInventoryRelocationActivity)
